import moment from 'moment'
import {
  DEFAULT_MAX_DATE,
  DEFAULT_MIN_DATE,
  DEFAULT_DATE_FORMAT,
  PICKER_DATE_FORMAT,
} from 'config'

export const formatDate = (
  date: string | moment.Moment | Date | null,
  format?: string
) => (date ? moment(date).format(format || DEFAULT_DATE_FORMAT) : '')

export const isDateValid = (value: string | number | moment.Moment | Date) => {
  const minDate = moment(DEFAULT_MIN_DATE, PICKER_DATE_FORMAT)
  const maxDate = moment(DEFAULT_MAX_DATE, PICKER_DATE_FORMAT)
  const date = moment(value)

  return date.isValid() && date.isBetween(minDate, maxDate)
}

export const parseToSafariDateTime = (date: string) => date.replace(/ /g, 'T')

export const dateWithoutTime = (date: Date) => {
  const newDate = new Date(date)
  newDate.setUTCHours(0, 0, 0, 0)
  return newDate
}
